import React from "react";
import Query from "react-apollo/Query";
import { GET_AGENT_OFFERS } from "../../../queries";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import { referalLang } from "./referalLang";

class RefferalStatTable extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            Language: localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({hideNav: window.innerWidth <= 1100});
    }

    render() {
        return (
            <div className="MarketPageWithdrawalMoneyIn MarketPageWithdrawalMoneyIn02">
                <div className="row width98p">
                    <div className="col-md-12">
                        <div className="CertTable mt10px">
                            <table>
                                <thead>
                                    <tr>
                                        <th>E-mail</th>
                                        <th>{referalLang.amount[this.state.Language]}</th>
                                        <th>$ARTY</th>
                                        <th>{referalLang.amount_coin[this.state.Language]}</th>
                                        <th>{referalLang.package[this.state.Language]}</th>
                                        <th>{referalLang.status[this.state.Language]}</th>
                                        <th>{referalLang.time[this.state.Language]}</th>                                        
                                    </tr>
                                </thead>
                                <tbody>
                                <Query query = {GET_AGENT_OFFERS} variables={{ email: this.props.session.email }}>
                                    {({ data, loading, error}) => {
                                        if (loading) return <div>loading</div>;
                                        if (error) {
                                            window.open(`${process.env.SITE_ADDRESS}/noauth/`, '_top'); 
                                            return <div>error</div>;
                                        }

                                        const AllOffers = data.getCurrentAgentOffers.map( function(offer, i) {
                                            let status;
                                            if (offer.status == -1) {status = 'Cancelled'};
                                            if (offer.status == 0) {status = 'Pending'};
                                            if (offer.status == 1) {status = 'Success'};
                                            return (
                                                <tr>
                                                    <td>{offer.email}</td>
                                                    <td>{offer.ammount} $</td>
                                                    <td>{offer.arno}</td>
                                                    <td>{offer.coin_ammount} {offer.currency2}</td>
                                                    <td>{offer.item_name}</td>
                                                    <td>{status}</td>
                                                    <td>{offer.payment_time}</td>
                                                </tr>
                                            )
                                        });

                                        return <>{AllOffers}</>
                                    }
                                    }
                                </Query>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withAuth(session => session && session)(withRouter(RefferalStatTable));